import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import {
  getInSystemNotifications,
  clearInSystemNotifications,
} from '../../../../actions/system/';
import {
  IN_SYSTEM_NOTIFICATION_PATH,
  NEW_IN_SYSTEM_NOTIFICATION_PATH,
} from '../../../../config/paths';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import { IN_SYSTEM_NOTIFICATIONS_COLUMNS } from '../../../../config/columns';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';

export class InSystemNotifications extends Component {
  componentWillUnmount() {
    this.props.dispatchClearInSystemNotifications();
  }

  render() {
    const {
      notifications,
      loading,
      dispatchGetInSystemNotifications,
      breadcrumbs,
    } = this.props;
    const data = notifications.get('content') || [];
    const pages = notifications.get('totalPages') || null;
    const defaultPageSize = notifications.get('size') || DEFAULT_PAGE_SIZE;

    return (
      <ModuleList
        title="Notificaciones Internas del Sistema"
        breadcrumbs={breadcrumbs}
        buttonPath={NEW_IN_SYSTEM_NOTIFICATION_PATH}
        tableStructure={{
          columns: IN_SYSTEM_NOTIFICATIONS_COLUMNS,
          data,
          pages,
          defaultPageSize,
          filterable: false,
          fetchData: dispatchGetInSystemNotifications,
          modelPath: IN_SYSTEM_NOTIFICATION_PATH,
          loading,
          navigateToModelOnRowClick: true,
        }}
      />
    );
  }
}

const mapDispatchToProps = {
  dispatchGetInSystemNotifications: getInSystemNotifications,
  dispatchClearInSystemNotifications: clearInSystemNotifications,
};

const mapStateToProps = ({ SystemUnit }) => ({
  breadcrumbs: [
    ...SystemUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Notificaciones Internas del Sistema',
      href: IN_SYSTEM_NOTIFICATION_PATH,
    },
  ],
  notifications: SystemUnit.InSystemNotification.getIn(['all', 'content']),
  loading: SystemUnit.InSystemNotification.getIn(['all', 'loading']),
});

InSystemNotifications.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  notifications: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetInSystemNotifications: PropTypes.func.isRequired,
  dispatchClearInSystemNotifications: PropTypes.func.isRequired,
};

InSystemNotifications.defaultProps = {
  notifications: null,
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(InSystemNotifications);
